<template>
  <div>
    <md-empty-state v-if="loggedin"
      md-icon="assignment"
      md-label="Start Labeling Data"
      md-description="Take your time, the more accurate and consistent the data, the better the model.">
      <md-button class="md-primary md-raised" to="/Jobs">Get Started</md-button>
    </md-empty-state>
    <md-empty-state v-if="!loggedin"
      md-icon="verified_user"
      md-label="Please Login"
      md-description="We take data security seriously">
      <md-button class="md-primary md-raised" v-on:click="login()">Login Here</md-button>
    </md-empty-state>
  </div>
</template>

<script>
export default {
  data: () => ({
    loggedin: false
  }),
  methods: {
    login: function () {
      this.$auth.login()
    }
  },
  created () {
    this.loggedin = this.$auth.isAuthenticated()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Hello.vue